/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Event_Ends_SuccessInputs */



/**
* | output |
* | --- |
* | "Snap to event ends finished successfully" |
*
* @param {Snap_To_Event_Ends_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_event_ends_success = /** @type {((inputs?: Snap_To_Event_Ends_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Event_Ends_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Alignement sur la fin des événements terminé avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Snap to event ends erfolgreich abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'aggancio alla fine dell'evento è stato completato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Снимок экрана для завершения мероприятия успешно завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustar al evento finaliza correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快照事件结束已成功完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント終了時のスナップが正常に完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्नैप टू इवेंट सफलतापूर्वक समाप्त हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O evento Snap to Event foi concluído com sucesso.")
	return /** @type {LocalizedString} */ ("Snap to event ends finished successfully")
});